import type { BoxShadowData } from './types';

export function isBoxShadow(data: any): data is BoxShadowData {
	return (
		typeof data === 'object' &&
		typeof data.shadowType === 'string' &&
		typeof data.xOffset === 'number' &&
		typeof data.yOffset === 'number' &&
		typeof data.blur === 'number' &&
		typeof data.spread === 'number' &&
		typeof data.color === 'string'
	);
}
